const config = {
  "GST": {
    "AB": 0.05,
    "BC": 0.05,
    "MB": 0.05,
    "NT": 0.05,
    "NU": 0.05,
    "ON": 0.13,
    "PE": 0.05,
    "PQ": 0.05,
    "SK": 0.05,
    "YT": 0.05,
    "NB": 0.13,
    "NL": 0.13,
    "NS": 0.15
  },
  "NomineeInsurance": {
    "SK": 0,
    "ON": 0.08,
    "MB": 0.07,
    "PQ": 0.09
  },
  "CompletionInsurance": {
    "SK": 0,
    "ON": 0.08,
    "MB": 0.07,
    "PQ": 0.09
  },
  "PaymentProtectionInsurance": {
    "SK": 0,
    "ON": 0.08,
    "MB": 0.07,
    "PQ": 0.09
  },
  "CriticalIllnessInsurance": {
    "SK": 0,
    "ON": 0.08,
    "MB": 0.07,
    "PQ": 0.09
  }
}

export default config;